import React from 'react'
import { render } from 'react-dom';
import './styles/global';

import App from './App'

render(<App />, document.getElementById('root'))